<template>
  <generic-modal :modal-key="'welcome_sign_up'"
                 :hasExtraModalClass="'modal modal--welcomeback modal--zero-balance'"
                 :classStyle="'modal__content modal_welcome modal_cont'"
                 :idProp="'modal_no_spinning'"
                 @close="$emit('close')">
    <template slot="content">
      <div class="black-overlay"></div>
        <div class="modal modal--welcomeback" id="welcome_modal">
          <div class="modal__content">
            <button class="btn modal-close"><i class="icon-close"></i></button>
            <div class="modal__body">
              <div class="logo_form"><img :src="getTranslations.project_logo_img" alt=""></div>
              <h1>{{ getTranslations.home_modals_welcome_sign_up_welcome }}</h1>
              <p class="upper_section_modal">
                {{ getTranslations.home_modals_welcome_sign_up_text_0 +
                   getTranslations.home_modals_welcome_sign_up_text_1 +
                   getTranslations.home_modals_welcome_sign_up_text_2 }}
              </p>
              <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
            </div>
            <div class="modal__footer"><span class="terms">
              <span class="make_it_bold"> {{ getTranslations.home_modals_welcome_sign_up_note_note }} </span>
                {{ getTranslations.home_modals_welcome_sign_up_note_text }} <br>
            </span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
    </template>
  </generic-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'welcome-signup',
  components: { GenericModal },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeSignup.vue